// import "jquery";
import Router from "./util/Router";

import PageController from "./util/page-controller";

import common from "./routes/common";
import home from "./routes/home";
import postTypeArchiveProducts from "./routes/post-type-archive-products";
import taxProductCategories from "./routes/post-type-archive-products";
import postTypeArchiveRecipes from "./routes/post-type-archive-recipes";
import taxRecipeCategory from "./routes/tax-recipe_category";
import postTypeArchiveStockist from "./routes/post-type-archive-stockist";
import singleProducts from "./routes/single-products";
import singleRecipes from "./routes/single-recipes";
// import pageTemplateContact from "./routes/page-template-contact";
// import pageTemplateMission from "./routes/page-template-mission";
import pageTemplateBlog from "./routes/page-template-blog";
import category from "./routes/page-template-blog";
import singleJobs from "./routes/single-jobs";

const routes = new Router({
    common,
    home,
    postTypeArchiveProducts,
    taxProductCategories,
    postTypeArchiveRecipes,
    taxRecipeCategory,
    postTypeArchiveStockist,
    singleProducts,
    singleRecipes,
    // pageTemplateContact,
    // pageTemplateMission,
    pageTemplateBlog,
    category,
    singleJobs,
});

function ready(func) {
    if (
        document.attachEvent
            ? document.readyState === "complete"
            : document.readyState !== "loading"
    ) {
        func();
    } else {
        document.addEventListener("DOMContentLoaded", func);
    }
}

function loadEvents() {
    if (
        document.body.classList.contains("ie") ||
        document.body.classList.contains("edge")
    ) {
        routes.loadEvents();
    } else {
        const pagecontroller = new PageController({
            events: {
                afterLoad: function () {
                    routes.loadEvents();
                },
            },
        });
    }

    // routes.loadEvents();
}

ready(loadEvents);



// WEBPACK FOOTER //
// ./js/main.js